import { render, staticRenderFns } from "./TableOneTimePay.vue?vue&type=template&id=670ee476&scoped=true"
import script from "./TableOneTimePay.vue?vue&type=script&lang=js"
export * from "./TableOneTimePay.vue?vue&type=script&lang=js"
import style0 from "./TableOneTimePay.vue?vue&type=style&index=0&id=670ee476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670ee476",
  null
  
)

export default component.exports